import React from 'react'

const Skills = () => {
/*==================== ACCORDION SKILLS ====================*/
const skillsContent = document.getElementsByClassName('skills__content'),
      skillsHeader = document.querySelectorAll('.skills__header')


      const toggleSkills = (event) => {
        debugger
        let itemClass = event.currentTarget.parentElement.className
    
        for (let i = 0; i < skillsContent.length; i++) {
           skillsContent[i].className = 'skills__content skills__close'
        }
    
        if (itemClass === 'skills__content skills__close') {
            event.currentTarget.parentElement.className ='skills__content skills__open'
        }
      };

// skillsHeader.forEach((el)=>{
//     el.addEventListener('click',toggleSkills)
// })




  return (
    <>
    <section className="skills section" id="skills">
                <h2 className="section__title">Skills</h2>
                <span className="section__subtitle">My technical level</span>

                <div className="skills__container container grid">
                   
                         <div className="skills__content skills__open">
                            <div className="skills__header" onClick={toggleSkills}>
                                <i className='uil uil-brackets-curly skills__icon'></i> 

                                <div>
                                    <h1 className="skills__title">Frontend Developer</h1>
                                    <span className="skills__subtitle">More than 1 years</span>
                                </div>

                                <i className='uil uil-angle-down skills__arrow'></i>
                            </div>

                            <div className="skills__list grid">

<ul>
    <li>HTML</li>
    <li>CSS</li>
    <li>Bootstrap and Tailwind CSS</li>
    <li>Javascript</li>
    <li>Jquery</li>
    <li>React and Redux</li>
</ul>


                                {/* <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">HTML</h3>
                                        <span className="skills__number">90%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__html"></span>
                                    </div>
                                </div>
                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">CSS</h3>
                                        <span className="skills__number">80%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__css"></span>
                                    </div>
                                </div>
                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Javascript</h3>
                                        <span className="skills__number">60%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__js"></span>
                                    </div>
                                </div>
                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">React</h3>
                                        <span className="skills__number">75%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__react"></span>
                                    </div>
                                </div> */}
                            </div>
                         </div>


                        
                          <div className="skills__content skills__close">
                            <div className="skills__header" onClick={toggleSkills}>
                                <i className='uil uil-server-network skills__icon'></i> 

                                <div>
                                    <h1 className="skills__title">Backend Developer</h1>
                                    <span className="skills__subtitle">More than 1 years</span>
                                </div>

                                <i className='uil uil-angle-down skills__arrow'></i>
                            </div>

                            <div className="skills__list grid">
                            <ul>
    <li>Springboot (Java)</li>
    <li>.Net Core MVC</li>
    <li>MySQL</li>
</ul>
                                {/* <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">Java (Springboot)</h3>
                                        <span className="skills__number">60%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__node"></span>
                                    </div>
                                </div>
                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">MySQL</h3>
                                        <span className="skills__number">60%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__css"></span>
                                    </div>
                                </div>
                                <div className="skills__data">
                                    <div className="skills__titles">
                                        <h3 className="skills__name">.Net MVC Core</h3>
                                        <span className="skills__number">45%</span>
                                    </div>
                                    <div className="skills__bar">
                                        <span className="skills__percentage skills__js"></span>
                                    </div>
                                </div> */}
                               
                            </div>
                         </div>
                </div>
            </section>
    </>
  )
}

export default Skills